module.exports = __webpack_public_path__ + "static/media/LivestreamPPV.svg";